import { faMicrophone, faStopCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "@material-ui/core";
import { Auth } from "aws-amplify";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {
  ChatContainer,
  InputToolbox,
  MainContainer,
  MessageInput,
  MessageList,
  TypingIndicator,
} from "@chatscope/chat-ui-kit-react";
import { useState } from "react";
export default function HindwareDealer({ title, link }) {
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [trainload, setTrainload] = useState(false);
  const [answerload, setAnswerload] = useState(false);
  const [displayText, setDisplayText] = useState("");
  // const [question, setQuestion] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");
  const [feedbackResponses, setFeedbackResponses] = useState([]);
  const [deleteError, setdeleteError] = useState("");
  const [chatbotFeedback, setChatbotFeedback] = useState([]);
  // const [selectedModel, setSelectedModel] = useState("meta.llama2-13b-chat-v1");
  // const [modeltext, setModelText] = useState("LLAMA 13b");
  const [userName, setUsername] = useState("");
  const timetaken = useRef(0);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [messages, setMessages] = useState([]);
  const [genaiaccess, setgenaiaccess] = useState(false);
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [transcript, setTranScript] = useState("");
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const messagesEndRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [isStartChatStarted, setIsStartChatStarted] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [selectedVoice, setSelectedVoice] = useState(null);

  useEffect(() => {
    if (messages.length > 0) {
      const lastMessage = messages[messages.length - 1]; // Get the last message

      const messageList = messagesEndRef.current?.parentNode;
      if (messageList) {
        if (lastMessage.direction === "incoming") {
          // Apply the 3-second delay for incoming messages
          setTimeout(() => {
            messageList.scrollTop = messageList.scrollHeight;
          }, 3000);
        } else {
          // No delay for outgoing messages
          messageList.scrollTop = messageList.scrollHeight;
        }
      }
    }
  }, [messages]);

  useEffect(() => {
    if (transcript.length > 0) {
      // console.log("Original Transcript: ", transcript);
      const formattedTranscript = formatResponse(transcript);
      // console.log("Formatted Response: ", formattedTranscript);
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + formattedTranscript[index]);
        index++;
        if (index === formattedTranscript.length) {
          clearInterval(intervalId);
          setTranScript("");
        }
      }, 1);
    }
  }, [transcript]);

  const formatResponse = (response) => {
    // Replacing markdown-like headers with HTML headers
    const headers = response
      .replace(/(######\s?)(.*?)\n/g, "<h6>$2</h6>")
      .replace(/(#####\s?)(.*?)\n/g, "<h5>$2</h5>")
      .replace(/(####\s?)(.*?)\n/g, "<h4>$2</h4>")
      .replace(/(###\s?)(.*?)\n/g, "<h3>$2</h3>")
      .replace(/(##\s?)(.*?)\n/g, "<h2>$2</h2>")
      .replace(/(#\s?)(.*?)\n/g, "<h1>$2</h1>");

    // Splitting and replacing bold markers
    let responseArray = headers.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    // Replace asterisks and newlines for proper HTML formatting
    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  useEffect(() => {
    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    const userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    const jsondata = JSON.parse(userdata);
    const emailObj = jsondata.UserAttributes.find(
      (item) => item.Name === "email",
    );
    const email = emailObj?.Value || "";

    setgenaiaccess(email.includes("genai2244"));
  }, []);

  useEffect(() => {
    const loadVoices = () => {
      const availableVoices = window.speechSynthesis.getVoices();

      const englishVoice = availableVoices.find(
        (voice) => voice.lang === "en-GB" || voice.lang === "en-US",
      );

      const fallbackVoice = availableVoices.find((voice) =>
        voice.lang.startsWith("en"),
      );

      setSelectedVoice(englishVoice || fallbackVoice);

      if (!englishVoice && !fallbackVoice) {
        console.warn("No suitable English voice found; using default voice.");
      }
    };

    if (window.speechSynthesis.onvoiceschanged !== undefined) {
      window.speechSynthesis.onvoiceschanged = loadVoices;
    } else {
      loadVoices();
    }

    // Stop speech if any other button is clicked
    const handleButtonClick = (event) => {
      if (
        event.target.tagName === "BUTTON" &&
        !event.target.classList.contains("speak-button")
      ) {
        window.speechSynthesis.cancel();
        setIsSpeaking(false);
      }
    };

    // Stop speech when the page is about to unload (refresh or navigate away)
    const handleBeforeUnload = () => {
      window.speechSynthesis.cancel();
    };

    // Add event listeners for button clicks and page unload
    document.addEventListener("click", handleButtonClick);
    window.addEventListener("beforeunload", handleBeforeUnload);

    // Cleanup: Remove event listeners on unmount
    return () => {
      document.removeEventListener("click", handleButtonClick);
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.speechSynthesis.cancel();
    };
  }, []);

  const speak = (message) => {
    const synth = window.speechSynthesis;

    // Filter out emojis using a regular expression
    const cleanedMessage = String(message).replace(
      /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
      "",
    );

    if (isSpeaking) {
      // If currently speaking, stop the speech
      synth.cancel();
      setIsSpeaking(false);
    } else {
      // Otherwise, start speaking the cleaned message
      const utterance = new SpeechSynthesisUtterance(cleanedMessage);
      if (selectedVoice) {
        utterance.voice = selectedVoice;
      }
      utterance.pitch = 1.0;
      utterance.rate = 1.0;

      synth.speak(utterance);
      setIsSpeaking(true);

      // Set isSpeaking to false when speaking stops
      utterance.onend = () => setIsSpeaking(false);
    }
  };

  const handleSpeakFeedback = () => {
    if (chatbotFeedback) {
      const cleanedFeedback = chatbotFeedback.replace(
        /[\u{1F600}-\u{1FAFF}\u{2600}-\u{27BF}:;,.!?*#]/gu,
        "",
      );
      speak(cleanedFeedback);
    }
  };

  const handleSendMessage = (messageText, inputId) => {
    if (messageText.trim() === "") {
      return;
    }
    // if (currentPayload.activity_4_condition === true) {
    //   messageText = `Manager: ${messageText}`;
    // }
    // Create a new message object
    const newMessage = {
      id: Math.random().toString(),
      text: messageText,
      sender: "User",
      direction: "outgoing",
    };
    // Update the messages state by adding the new message
    setMessages((prevMessages) => [...prevMessages, newMessage]);
    handleQuestion1(messageText);
  };

  const handleStart = async () => {
    setIsStartChatStarted(true);
    console.log("Handle Start is calling");

    // Reset any previous conversation and disable input field during loading
    setMessages([]);
    setIsInputDisabled(true);
    setAnswerload(true);
    setTranScript("");
    setDisplayText("");
    setFeedbackResponses([]);
    setProgress(0);

    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );

    // Reset the current payload for a fresh start
    const resetPayload = {
      response: "",
      feedback: "",
      initial_condition: true,
      second_condition: false,
      conversation_list: [],
      status: false,
      salesperson_response: "",
    };

    setCurrentPayload(resetPayload);
    // setCurrentPayload(initialPayload);
    console.log("Initial Payload before sending:", resetPayload);

    try {
      // Send a POST request to the backend with the initial payload
      const response = await fetch(
        "https://imgqtfwjnae4ewkaeztznr4wb40dzwfn.lambda-url.ap-south-1.on.aws/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(resetPayload), // Send the reset payload
        },
      );

      const data = await response.json();
      console.log("First Response data:", data);

      // if (data.message.response) {
      //   speak(data.message.response);
      // }

      // Update the messages with the backend response (e.g., welcome message)
      setMessages((prevMessages) => [
        ...prevMessages,
        {
          text: data.message.response,
          direction: "incoming",
        },
      ]);

      setCurrentPayload((prevPayload) => ({
        ...prevPayload,
        ...data.message,
      }));

      setAnswerload(false);
      setIsInputDisabled(false);
    } catch (error) {
      console.error("Error fetching initial message:", error);

      // Stop loading and allow retry
      setAnswerload(false);
      setIsInputDisabled(false);
    }
  };

  const [currentPayload, setCurrentPayload] = useState({
    response: "",
    feedback: "",
    initial_condition: true,
    second_condition: false,
    conversation_list: [],
    status: false,
    salesperson_response: "",
  });

  const handleQuestion1 = async (question) => {
    setTranScript("");
    setDisplayText("");

    if (question.length > 0) {
      timetaken.current = 0;

      // Start timer to track time taken for the request
      let time = setInterval(() => {
        timetaken.current = parseFloat(timetaken.current) + 0.1;
      }, 100);

      setAnswerload(true);
      console.log("requesting");

      // Update the current payload with the new question and conversation list
      const updatedPayload = {
        ...currentPayload, // Get the latest state
        conversation_list: [...currentPayload.conversation_list, question],
        salesperson_response: question,
      };

      console.log("Payload being sent in the second request:", updatedPayload);

      try {
        // Send the updated payload to the backend
        const response = await fetch(
          "https://imgqtfwjnae4ewkaeztznr4wb40dzwfn.lambda-url.ap-south-1.on.aws/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(updatedPayload), // Send the updated payload
          },
        );

        const data = await response.json();
        console.log("Second Response Data:", data);

        setAnswerload(false);

        // Extract response message and feedback
        const chatbotMessage = data.message.response || "No message available";
        const chatbotConclusion = data.message.feedback || "";
        // console.log(chatbotConclusion, "111");
        // setChatbotFeedback(chatbotConclusion);
        // if (chatbotMessage) {
        //   speak(chatbotMessage);
        // }
        // Only update the flags or fields returned by the backend
        const updatedFlags = {
          // Update only if the backend provides the value, otherwise keep the current value
          initial_condition:
            data.message.initial_condition !== undefined
              ? data.message.initial_condition
              : currentPayload.initial_condition,
          second_condition:
            data.message.second_condition !== undefined
              ? data.message.second_condition
              : currentPayload.second_condition,
          status:
            data.message.status !== undefined
              ? data.message.status
              : currentPayload.status,
        };

        // Calculate progress directly after updating flags.
        setCurrentPayload((prevPayload) => {
          const mergedPayload = {
            ...prevPayload,
            ...updatedFlags, // Merge flags from backend response
            conversation_list: [
              ...prevPayload.conversation_list,
              question,
              chatbotMessage,
            ], // Add chatbot message
          };

          return mergedPayload;
        });

        // Add chatbot message to the UI
        const newMessage = {
          id: Math.random().toString(),
          text: chatbotMessage,
          sender: "Chatbot",
          direction: "incoming",
          feedback: chatbotConclusion,
        };

        clearInterval(time);
        setMessages((prevMessages) => [...prevMessages, newMessage]);
        setTranScript(chatbotConclusion);

        // Add feedback conclusion to the feedback list
        if (chatbotConclusion.trim()) {
          setFeedbackResponses((prevFeedback) => [
            ...prevFeedback,
            {
              text: `Feedback ${prevFeedback.length + 1}`,
              conclusion: chatbotConclusion,
              id: Math.random().toString(),
            },
          ]);
        }
      } catch (error) {
        console.error("Error occurred during the request:", error);
        setAnswerload(false);

        // Show an error message in the chat
        const errorMessage = {
          id: Math.random().toString(),
          text: "Something went wrong",
          sender: "Chatbot",
          direction: "incoming",
        };
        setMessages((prevMessages) => [...prevMessages, errorMessage]);
        clearInterval(time);
      }
    } else {
      setError("Please enter a question");
    }
  };

  const handleFeedbackClick = (response) => {
    setDisplayText(formatResponse(response.conclusion)); // Show the full conclusion in the feedback window
  };

  const [transcription, setTranscription] = useState("");
  const [isRecording, setIsRecording] = useState(false);

  const audioContextRef = useRef(null);
  const processorRef = useRef(null);
  const streamRef = useRef(null);
  const audioChunksRef = useRef([]);

  const captureAudio = () => {
    if (isRecording) return;

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        setIsRecording(true);
        const audioContext = new AudioContext({ sampleRate: 16000 });
        audioContextRef.current = audioContext;

        const input = audioContext.createMediaStreamSource(stream);
        const processor = audioContext.createScriptProcessor(4096, 1, 1);
        processorRef.current = processor;
        streamRef.current = stream;

        input.connect(processor);
        processor.connect(audioContext.destination);

        processor.onaudioprocess = (event) => {
          const audioData = event.inputBuffer.getChannelData(0);
          audioChunksRef.current.push(new Float32Array(audioData));
          console.log("Audio chunk received:", audioData.length);
        };

        console.log("Recording started");
      })
      .catch((err) => {
        console.error("Error capturing audio:", err);
      });
  };

  const handleMicrophoneStop = () => {
    if (!isRecording) return;

    if (processorRef.current) {
      processorRef.current.disconnect();
    }
    if (audioContextRef.current) {
      audioContextRef.current.close();
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
    }

    setIsRecording(false);
    console.log("Recording stopped");

    if (audioChunksRef.current.length === 0) {
      console.error("No audio data captured");
      return;
    }

    const totalLength = audioChunksRef.current.reduce(
      (acc, chunk) => acc + chunk.length,
      0,
    );
    const fullAudioBuffer = new Float32Array(totalLength);
    let offset = 0;
    for (const chunk of audioChunksRef.current) {
      fullAudioBuffer.set(chunk, offset);
      offset += chunk.length;
    }

    console.log("Total audio length (samples):", fullAudioBuffer.length);

    audioChunksRef.current = [];

    // Send the audio buffer for transcription
    sendAudioToServer(fullAudioBuffer).then((transcriptionText) => {
      if (transcriptionText.startsWith("Error")) {
        console.error(transcriptionText);
      } else {
        // Call handleSendMessage with the transcription
        handleSendMessage(transcriptionText);
      }
    });
  };

  const sendAudioToServer = async (fullAudioBuffer) => {
    try {
      const int16Buffer = convertFloat32ToInt16(fullAudioBuffer);
      console.log("Int16 Buffer Length:", int16Buffer.length);

      const base64Audio = arrayBufferToBase64(int16Buffer.buffer);
      console.log("Base64 Audio Length:", base64Audio.length);

      const data = {
        "audio-data": base64Audio,
      };

      const response = await fetch(
        "https://2ebgwsxstddkvpgcehqjrhoflu0lerly.lambda-url.ap-south-1.on.aws/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        },
      );

      const jsonResponse = await response.json();
      console.log("Server Response:", jsonResponse);

      if (response.ok && jsonResponse.transcription) {
        return jsonResponse.transcription;
      } else {
        console.error("Error from server:", jsonResponse);
        return `Error processing transcription: ${
          jsonResponse.message || "Unknown error"
        }`;
      }
    } catch (error) {
      console.error("Error sending audio data:", error);
      return `Error sending audio data: ${error.message || "Unknown error"}`;
    }
  };

  const convertFloat32ToInt16 = (buffer) => {
    const int16Buffer = new Int16Array(buffer.length);
    for (let i = 0; i < buffer.length; i++) {
      let s = Math.max(-1, Math.min(1, buffer[i]));
      int16Buffer[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }
    return int16Buffer;
  };

  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  const handleButtonClick = () => {
    if (isRecording) {
      handleMicrophoneStop();
    } else {
      captureAudio();
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#FFFFFF",
        minHeight: "100vh",
        padding: "1rem",
      }}
    >
      {/* Header Section */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1rem",
        }}
      >
        <Link to={link}>
          <Button variant="contained" component="span" color="primary">
            Back
          </Button>
        </Link>
        <h2 style={{ fontWeight: "bold", color: "#333333" }}>{title}</h2>
        <Button
          style={{
            backgroundColor: "#ffa502",
          }}
          variant="contained"
          onClick={() => {
            signOut();
          }}
          color="primary"
          component="span"
        >
          Sign Out
        </Button>
      </div>

      {/* Main Content Section */}
      {genaiaccess ? (
        <div
          style={{
            display: "flex",
            height: "85vh",
            // gap: "1rem",
            // padding: "1rem",
          }}
        >
          {/* Chat Window (7 parts) */}
          <div
            style={{
              flex: 7,
              backgroundColor: "#F7F8FA",
              padding: "1rem",
              borderRadius: "1rem",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              display: "flex",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
                fontFamily: "'Outfit', sans-serif",
              }}
            >
              <h3 style={{ margin: 0 }}>
                <strong>Dealer Pitch</strong>
              </h3>
              <Button
                variant="contained"
                color="primary"
                onClick={handleStart}
                style={{ fontSize: "0.9rem", padding: "0.5rem 1rem" }}
              >
                {isStartChatStarted ? "Restart Chat" : "Start Chat"}
              </Button>
            </div>
            <MainContainer
              style={{
                borderRadius: "1rem",
                backgroundColor: "#FFFFFF",
                boxShadow: "inset 0 2px 8px rgba(0, 0, 0, 0.05)",
                flex: 1,
                display: "flex",
                flexDirection: "column",
                height: "100%",
              }}
            >
              <ChatContainer
                style={{
                  padding: "1rem",
                  backgroundColor: "#FFFFFF",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  flexGrow: 1,
                  overflow: "hidden",
                }}
              >
                <MessageList
                  style={{
                    color: "#333333",
                    backgroundColor: "#FFFFFF",
                    flexGrow: 1,
                    overflowY: "auto",
                    marginBottom: "1rem",
                    paddingRight: "1rem",
                    maxHeight: "calc(100% - 60px)",
                  }}
                  typingIndicator={
                    answerload && (
                      <TypingIndicator content="Dealer is typing..." />
                    )
                  }
                  autoScrollToBottomOnMount={true}
                >
                  {Array.isArray(messages) &&
                    messages.map((message, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "flex-end",
                          marginBottom: "1rem",
                          justifyContent:
                            message.direction === "outgoing"
                              ? "flex-end"
                              : "flex-start",
                        }}
                      >
                        {message.direction === "incoming" && (
                          <>
                            <img
                              src="/assets/images/chatbot1.png"
                              alt="Chatbot Icon"
                              style={{
                                marginRight: "0.5rem",
                                width: "38px",
                                height: "38px",
                                borderRadius: "50%",
                              }}
                            />
                            <div
                              style={{
                                fontFamily: "'Outfit', sans-serif",
                                fontSize: "1rem",
                                backgroundColor: "#E0E0E0",
                                padding: "0.75rem 1.5rem",
                                borderRadius: "20px 20px 20px 0",
                                maxWidth: "91%",
                                wordWrap: "break-word",
                              }}
                            >
                              <CharacterByCharacter
                                message={message.text}
                                messagesEndRef={messagesEndRef}
                                onComplete={message.onComplete}
                              />
                            </div>
                          </>
                        )}

                        {message.direction === "outgoing" && (
                          <>
                            <div
                              style={{
                                fontFamily: "'Outfit', sans-serif",
                                fontSize: "1rem",
                                // backgroundColor: "#6EA9D7 ",
                                backgroundColor: "#BCD3EA",
                                padding: "0.75rem",
                                borderRadius: "20px 20px 0 20px",
                                maxWidth: "70%",
                                wordWrap: "break-word",
                                // textAlign: "right",
                                color: "#333333",
                                marginRight: "0.5rem",
                              }}
                            >
                              {message.text}
                            </div>
                            <img
                              src="/assets/images/man_icon.png"
                              alt="User Icon"
                              style={{
                                marginLeft: "0.5rem",
                                width: "38px",
                                height: "38px",
                                borderRadius: "50%",
                              }}
                            />
                          </>
                        )}
                      </div>
                    ))}
                  <div ref={messagesEndRef} />
                </MessageList>
                <InputToolbox
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <MessageInput
                    attachButton={false}
                    placeholder="Type your response here..."
                    onSend={(messageText) => {
                      let sanitizedMessage = messageText.replace(
                        /&nbsp;/g,
                        " ",
                      );

                      // Preserve leading spaces with &nbsp;
                      sanitizedMessage = sanitizedMessage.replace(
                        /^\s+/,
                        (match) => {
                          return match
                            .split("")
                            .map(() => "&nbsp;")
                            .join("");
                        },
                      );

                      handleSendMessage(sanitizedMessage.trim());
                    }}
                    disabled={
                      isInputDisabled ||
                      transcript.length > 0 ||
                      currentPayload.status === true ||
                      isSpeaking
                    }
                    style={{
                      fontFamily: "'Outfit', sans-serif",
                      borderRadius: "8px",
                      backgroundColor: "#F0F2F5",
                      color: "#121212",
                      padding: "0.75rem",
                      border: "1px solid #E0E0E0",
                      boxSizing: "border-box",
                      fontSize: "1rem",
                      width: "93%",
                      position: "relative",
                      zIndex: 10,
                      display: "flex", // Use flexbox
                      alignItems: "center",
                      gap: "10px",
                    }}
                  />
                  <button
                    onClick={handleButtonClick}
                    disabled={isInputDisabled || isSpeaking}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: isInputDisabled ? "not-allowed" : "pointer",
                      fontSize: "1rem",
                      fontFamily: "'Outfit', sans-serif",
                      color: "#121212",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      outline: "none",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={
                        isRecording || isSpeaking ? faStopCircle : faMicrophone
                      }
                      // icon={faMicrophone}
                      size="lg"
                      color={isRecording ? "red" : "black"}
                    />
                    <span
                      style={{
                        fontSize: "0.8rem",
                        marginTop: "4px",
                      }}
                    >
                      {isRecording ? "Stop" : "Speak"}
                    </span>
                  </button>
                </InputToolbox>
              </ChatContainer>
            </MainContainer>
          </div>

          {/* Right Side (3 parts) */}

          <div
            style={{
              flex: 3,
              fontFamily: "'Outfit', sans-serif",
              padding: "1rem",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <h3 style={{ margin: 0 }}>
                <strong>Pitch Feedback</strong>
              </h3>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {/* <Button
                  onClick={handleSpeakFeedback}
                  style={{
                    outline: "none",
                    marginLeft: "-4px",
                    backgroundColor: "transparent",
                  }}
                >
                  <img src="/assets/images/speaker.png" width="35px" />
                </Button> */}
              </div>
            </div>
            <div
              style={{
                color: "#333333",
                padding: "1rem",
                border: "1px solid #D1DBE3",
                borderRadius: "1rem",
                backgroundColor: "#FFFFFF",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                flex: 1,
                minHeight: "550px",
                fontSize: "1rem",
                overflowY: "auto",
              }}
            >
              {/* Feedback Buttons */}
              <div
                style={{
                  marginBottom: "1rem",
                  display: "flex",
                  flexWrap: "wrap", // Allow buttons to wrap to the next line
                  gap: "10px", // Optional: Add spacing between buttons
                }}
              >
                {feedbackResponses.map((response, index) => (
                  <Button
                    key={response.id}
                    variant="contained"
                    color="primary"
                    onClick={() => handleFeedbackClick(response)} // Display full feedback on click
                    // style={{
                    //   flex: "1 1 calc(33.33% - 10px)", // Ensure 3 buttons per row with space between
                    //   textTransform: "none",
                    //   marginBottom: "10px", // Spacing between rows
                    // }}
                    style={{
                      flex: "1 1 calc(33.33% - 10px)",
                      textTransform: "none",
                      marginBottom: "10px",
                      width: "100%",
                      minWidth: "120px",
                      maxWidth: "200px",
                      padding: "10px 20px",
                      boxSizing: "border-box",
                    }}
                  >
                    {response.text} {/* Shows Feedback 1, Feedback 2, etc. */}
                  </Button>
                ))}
              </div>

              {displayText.length > 0 ? (
                <div
                  style={{
                    color: "#333333",
                    fontFamily: "'Outfit', sans-serif",
                    wordWrap: "break-word",
                    whiteSpace: "pre-wrap",
                  }}
                  dangerouslySetInnerHTML={{ __html: displayText }}
                ></div>
              ) : (
                "Conversation feedback will be displayed here"
              )}
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "#333333", textAlign: "center" }}>
          You do not have access to use this section.
        </h2>
      )}
    </div>
  );
}

const CharacterByCharacter = ({ message, messagesEndRef, onComplete }) => {
  const [displayedText, setDisplayedText] = useState("");

  useEffect(() => {
    const formattedMessage =
      typeof message === "string" ? message : String(message);

    let responseArray = formattedMessage.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    let currentIndex = 0;
    // Calculate typing interval based on message length and speech rate
    // const estimatedSpeechDuration = (formattedMessage.length / 1.0) * 50; // Adjust multiplier if needed
    // const typingInterval = estimatedSpeechDuration / newResponse.length;

    const intervalId = setInterval(() => {
      setDisplayedText((prev) => prev + newResponse[currentIndex]);
      currentIndex += 1;
      // Trigger scroll every time a new character is displayed
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      }
      if (currentIndex === newResponse.length) {
        clearInterval(intervalId);
        if (onComplete) {
          onComplete(); // Notify when rendering is complete
        }
      }
    }, 1);

    return () => clearInterval(intervalId);
  }, [message, messagesEndRef, onComplete]);

  return <span dangerouslySetInnerHTML={{ __html: displayedText }} />;
};
